export function formatFullName(...parts) {
  return parts.filter((p) => p && String(p).trim()).join(' ').trim();
}

export function formatSmartDate(datetime, formatDateFn, todayLabel, yesterdayLabel) {
  if (!datetime) return 'NA';

  const date = new Date(datetime);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const target = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const timeOnly = formatDateFn(datetime, false, true);

  if (target.getTime() === today.getTime()) {
    return `${todayLabel || 'Today'} ${timeOnly}`;
  }
  if (target.getTime() === yesterday.getTime()) {
    return `${yesterdayLabel || 'Yesterday'} ${timeOnly}`;
  }
  return formatDateFn(datetime, true, true);
}
